export class WFEBankBalanceParameterDto {
    bankAccountId: number;
    communityId: number;

    getQueryString(): string {
        return `?communityId=${this.communityId}&bankAccountId=${this.bankAccountId}`;
    }
}
